var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-cascader", {
        ref: "areaCode",
        attrs: {
          "popper-class": _vm.checkStrictly ? "" : "area-code",
          disabled: _vm.disabled,
          placeholder: _vm.placeholder,
          options: _vm.areaList,
          clearable: _vm.clearable,
          size: _vm.size,
          props: {
            checkStrictly: _vm.checkStrictly,
            label: "name",
            value: "code",
            children: "child",
            multiple: _vm.multiple,
          },
          "show-all-levels": _vm.showAllLevels,
        },
        on: { change: _vm.handleChange },
        model: {
          value: _vm.convertedVal,
          callback: function ($$v) {
            _vm.convertedVal = $$v
          },
          expression: "convertedVal",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }